import { Link } from 'react-router-dom';
import styles from './EventItem.module.css';
import FavoriteButton from './FavoritesButton';
import ImageWithPlaceholder from './ImageWithPlaceholder';
import { DateUtil } from '../utils/DateUtil';
import { EventModel } from '../models/EventModel';
import { formatPrice } from '../utils/PriceUtil';
import { useSharedState } from '../hooks/useSharedState';
import recurringIcon from '../assets/recurring.svg';

interface EventItemProps {
    event: EventModel;
    reloadOnClick?: boolean;
    onClick?: () => void;
}

export default function EventItem ({event, reloadOnClick = false, onClick}: EventItemProps) {

    const [selectedCategories, ] = useSharedState('categories', '');
    const isRecurring = (event.recurringRules?.length ?? 0) > 0;

    const getCategoryToDisplay = (): string => {
        if (event.categories.length === 0) {
            return '';
        }

        if(event.categories.length == 1) {
            return event.categories[0].name;
        }

        const selectedSlugs = selectedCategories.split(';').filter(Boolean);
        const matchedCategory = event.categories.find((category) => selectedSlugs.includes(category.slug));

        if(matchedCategory) {
            return `${matchedCategory.name} +${event.categories.length - 1}`;
        }

        return event.categories[0].name + " +" + (event.categories.length -1);
    }

    return <div className={styles.eventItem}>
        <FavoriteButton eventId={event.id}/>
        <Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id} className={styles.imageLink}>
            {isRecurring && (
                <span
                    className={styles.recurringBadge}
                    aria-label="Événement récurrent"
                >
                    <span
                        aria-hidden="true"
                        className={styles.recurringBadgeIcon}
                        style={{
                            WebkitMaskImage: `url(${recurringIcon})`,
                            maskImage: `url(${recurringIcon})`,
                        }}
                    />
                    <span className={styles.recurringBadgeLabel} aria-hidden="true">Récurrent</span>
                </span>
            )}
            <ImageWithPlaceholder className={styles.eventItemImg} src={event.imageUrl} alt={event.title}/>
        </Link>
        <div className={styles.eventCategory} title={event.categories.map(c=>c.name).join(', ')} >{getCategoryToDisplay()}</div>
        <div className={styles.eventInfos}>
            <Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id} className={styles.titleLink}>
                <span className={styles.eventTileTitle}>{event.title}</span>
            </Link>
            <div className={styles.metaGroup}>
                <div>
                    <Link reloadDocument={true} to={"/venue/" + event.locationName} className={styles.venueLink}>
                        {event.locationName}
                        {event.distance_m && <span> — {Math.round(Number.parseFloat(event.distance_m))}m</span>}
                    </Link>
                </div>
                <div className={styles.eventDate}>
                    {event.dates ? DateUtil.getDayNameInFrench(event.dates[0]?.date) + ' ' + DateUtil.convertToAmericaToronto(event.dates[0]?.date, event.timeUnkown) : ''}
                </div>
                <div className={styles.priceLine}>{formatPrice(event.price)}</div>
            </div>
            <Link reloadDocument={reloadOnClick} onClick={onClick} to={"/details/" + event.id} className={styles.eventDetailsLink}>Détails</Link>
        </div>
    </div>;

}
